import { base_colorAction, progressBarBg } from 'ext-ui/style/colors'
import { progressBar_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

/**
 * CSS custom property carrying the `percentage` variant's fill width.
 *
 * Declared here rather than in the component so the import stays one-way
 * (`.tsx` imports `.style.ts`, never the reverse) — the component reads this
 * constant to set the property, this file reads it to consume it.
 */
export const VALUE_CUSTOM_PROPERTY = '--ProgressBar-value'

export default css`
  width: 100%;
  background-color: ${progressBarBg};
  height: 10px;
  border-radius: 5px;
  position: relative;

  .ProgressBar-inner {
    position: absolute;
    background-color: ${base_colorAction};
    top: 0;
    width: 100px;
    height: 10px;
    border-radius: 5px;
  }

  @keyframes slide-indeterminate {
    from {
      left: 0;
    }
    to {
      left: calc(100% - 100px);
    }
  }
  // VARIANTS
  &.indeterminate {
    .ProgressBar-inner {
      animation: slide-indeterminate 1s ease-in-out infinite alternate;
    }
  }

  &.percentage {
    .ProgressBar-inner {
      // Overrides the 100px the indeterminate slide animation needs. The
      // fallback keeps the fill at zero rather than 100px if the custom
      // property is ever missing, so a bug reads as "no progress" instead of
      // "some arbitrary progress".
      width: var(${VALUE_CUSTOM_PROPERTY}, 0%);

      @media (prefers-reduced-motion: no-preference) {
        transition: width ${progressBar_transitionSpeed} ease;
      }
    }
  }
`
